(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-dynamic-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ss-dynamic-row .ss-column').forEach(function (col) {
      var dataClass = col.dataset.class;
      if (!dataClass) return;

      col.parentElement.className = 'shopify-block ' + dataClass;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
